<template>
  <div class="text-center">
    <v-img
      width="500"
      class="mx-auto"
      contain
      src="~@/assets/images/mainpage.gif"
    />
    <h1 class="dastnevis red--text my-7">
      محتوای محدود
    </h1>
    <v-alert border="left" colored-border type="error" elevation="2">
      شما اجازه دسترسی به این بخش را ندارید
    </v-alert>
    <v-btn class="my-7" color="error" router to="/">
      بازگشت به صفحه اصلی
    </v-btn>
  </div>
</template>
<script>
export default {
  name: "restricted-component",
  data() {
    return {};
  }
};
</script>
